// extracted by mini-css-extract-plugin
export default {"trainOfferings":"styles_trainOfferings__dsrtK","wrap":"styles_wrap__gnRSM","content":"styles_content__ZCWSu","title":"styles_title__y3na9"};